import {
    CUSTOM_ROLE,
    DEFAULT_ROLES,
    RELATIONS,
    USER_RELATIONS
} from '../../app/root/constants'

const cz = {
    dashboard: {
        dashboard: 'Dashboard',
        switcherHoverTooltip: 'Nastavte a uložte výchozí zobrazení',
        mapView: 'MapView',
        defaultViewUpdateFail:
            'Nepodařilo se aktualizovat výchozí zobrazení řídicího panelu',
        addressUpdateSuccess: 'Adresa umístění byla úspěšně aktualizována',
        addressUpdateFail: 'Aktualizace adresy umístění se nezdařila',
        reports: 'Report z posledních 30 dní',
        deviceStatusTooltipText: {
            inactive: 'Tato zařízení se nepoužíDelete Custom Rolesvají ',
            critical: 'Tato zařízení vyžadují kontrolu',
            info: 'Zařízení fungují normálně',
            warning:
                'Zařízení mohou mít problémy s připojením nebo zkontrolujte stav baterie'
        },
        loggedInAs: 'Přihlášen jako: '
    },
    customers: {
        customer: 'Zákazník',
        customers: 'Zákazníci',
        plan: 'Softwarový plán',
        noCustomers: 'Nebyli nalezeni žádní zákazníci',
        noCustomer: 'Zákazník nebyl nalezen',
        hotswapPortal: 'HotSwap Portál',
        hotswapPortalAccess: 'Povolit přístup k procesu Hot Swap',
        hotswapUpdateService: 'Aktualizační služba',
        hotswapUpdateServiceAccess: 'Povoluje možnost aktualizační služby',
        hotswapWelcomeEmail: 'Uvítací email HotSwap',
        customerUsersTable: 'Tabulka uživatelů zákazníka',
        errorGettingUsersListForCustomer:
            'Chyba při získávání seznamu uživatelů'
    },
    hotSwap: {
        capacityIssueMessage:
            'Vážení zákazníci, vzhledem k současnému vysokému pracovnímu vytížení způsobenému dovolenou a objednávkami JERRY3 se rezervace Hotswap uvolňují každý čtvrtek v 15 hodin. Pokud rezervace Hotswap momentálně nejsou možné, prosíme o trochu trpělivosti. Kapacity aktualizujeme každý týden. V případě dotazů se můžete obrátit přímo na m.weigert@traplinked.com.',
        hotSwap: 'HotSwap',
        hotSwapAdmin: 'HotSwap Správce',
        hotSwapOrders: 'HotSwap Objednávky',
        startHotSwap: 'Spustit HotSwap',
        hotSwapVideoManual: 'Video manuál HotSwap',
        videoNotSupported: 'Váš prohlížeč nepodporuje video tag.',
        hotSwapType: 'Typ HotSwap',
        swapReplacment: 'Výměna Zařízení',
        description:
            'Některá vaše zařízení mohou vybíjet více energie, než se očekávalo. K vyřešení tohoto problému jsme vyvinuli nový firmware a stará zařízení je třeba vyměnit. Na této stránce můžete celý proces spravovat.',
        introVideo: 'Úvodní video',
        welcomeTitle: 'Vítejte v našem procesu HotSwap',
        welcomeDesc:
            'Jsme rádi, že jste s námi. Zde je několik rychlých tipů, jak začít.',
        summary: {
            changeLocation: 'Změnit umístění'
        },
        hotSwapTableEmptyListMessage:
            'Omlouváme se, v tuto chvíli nejsou k dispozici žádné položky pro okamžitou výměnu. Zkuste to později nebo kontaktujte podporu pro pomoc.',
        swap_by_user: {
            label: 'Objednat náhradní zařízení',
            title: 'Vyměňte si zařízení sami',
            description: 'Pošleme vám náhradní zařízení a vyměníte si je sami',
            features: {
                1: 'Objednat náhradní zařízení',
                2: 'Zapněte nová zařízení a vypněte stará zařízení',
                3: 'Flexibilní kdykoli to potřebujete'
            },
            stepper: {
                firstStepHeader: 'Plánování dopravy',
                firstStepSubHeader: 'Kdy máme zařízení odeslat?',
                secondStepHeader: 'Dodací adresa',
                secondStepSubHeader: 'Kam máme zařízení doručit?',
                thirdStepHeader: 'Shrnutí',
                thirdStepSubHeader: 'Potvrďte vaši objednávku HotSwap'
            },
            btnText: 'Objednat zařízení',
            summary: {
                date: 'Datum doručení',
                address: 'Dodací adresa'
            },
            successTitle: 'HotSwap úspěšně naplánován',
            successDesc:
                'Gratulujeme. Začneme připravovat vaše zařízení a doručíme je včas.',
            footerText: 'Tracking Number:',
            trackingLink: 'Sledovací odkaz:',
            detailsPageText: 'Shipping',
            termsAndConditonsLinkPart: 'Souhlasím s HotSwap',
            termsAndConditonsLink: 'Obchodní podmínky',
            termsAndConditonsTextHeader: 'Podmínky HotSwap',
            termsAndConditonsTextFirstParagraph:
                'V rámci procesu HotSwap souhlasíte s následujícími podmínkami:',
            termsAndConditonsTextSecondParagraph:
                "Pro výměnu skladových zařízení vytvořte prosím nové umístění v aplikaci traplinked a pojmenujte ho jako ['Název vaší společnosti' + Výměna zařízení ve skladu]. Přesuňte všechna LoRa zařízení, která se momentálně nacházejí ve vašem skladu, na toto nově vytvořené umístění, aby se usnadnila plynulá výměna zařízení.",
            termsAndConditonsTextThirdParagraph:
                'Pro výměnu zařízení umístěných na místech zákazníků vás laskavě žádáme, abyste ověřili přiřazení v aplikaci traplinked. Pokud jste nevytvořili žádné (zákaznické) umístění nebo nepoužíváte naši funkci umístění, protože pracujete pouze prostřednictvím rozhraní traplinked, obraťte se na nás, prosím, než si rezervujete náhradní zařízení prostřednictvím tohoto portálu.',
            termsAndConditonsTextFourthParagraph:
                'Jako součást procesu HotSwap souhlasíte s tím, že nám vrátíte vyměněná zařízení do 7 dnů od úspěšného dokončení procesu HotSwap na adrese (traplinked GmbH, Zollhof 7, 90443 Norimberk). Pokryjeme náklady na dopravu, a štítek pro vrácení bude zahrnut s vašimi náhradními zařízeními. Pokud dojde k zpoždění ve vrácení zásilek kvůli vašim akcím, mohou být na vás přeneseny případné dodatečné náklady. Potřebujeme vyměněná zařízení k urychlení přepracování všech systémů co nejrychleji.',
            termsAndConditonsTextFivethParagraph:
                'Jsme k dispozici k vaší pomoci a zodpovíme jakékoli otázky, které byste mohli mít během procesu HotSwap. Děkujeme vám za spolupráci a porozumění.'
        },
        update_service: {
            label: 'Rezervovat datum',
            title: 'Aktualizační služba od traplinked',
            description: 'Vaše zařízení aktualizujeme na současném místě',
            features: {
                1: 'Rezervovat schůzku',
                2: 'Aktualizováno technikem traplinked',
                3: 'Rychlé a pohodlné'
            },
            stepper: {
                firstStepHeader: 'Rezervace aktualizační služby',
                firstStepSubHeader: 'Kdy má přijít technik traplinked?',
                secondStepHeader: 'Adresa místa',
                secondStepSubHeader: 'Kde je toto místo?',
                thirdStepHeader: 'Shrnutí',
                thirdStepSubHeader: 'Potvrďte rezervaci aktualizační služby'
            },
            btnText: 'Rezervovat schůzku',
            summary: {
                date: 'Datum a čas',
                address: 'Adresa místa'
            },
            successTitle: 'Aktualizační služba úspěšně rezervována',
            successDesc:
                'Gratulujeme. Náš technik bude na definovaném místě v požadovaném termínu a čase.',
            footerText: 'Technician:',
            detailsPageText: 'Update Service'
        },
        rememberAddress: 'Zapamatovat dodací adresu',
        saveAddress: 'Uložte tuto adresu pro příští výměnu.',
        backToDashboard: 'Zpět na přehled',
        accordionDevicesTable: {
            exchangeDevice: 'Výměna zařízení',
            connectivity: 'Konnectivita',
            hbInterval: 'Interval HB',
            trapSide: 'Strana pasti',
            wifiData: 'WIFI Data'
        },
        carrier: 'Dopravce'
    },
    locations: {
        storageSectionTitle: 'Sklad',
        storageSectionNetworkDevicesTitle: 'Síťová zařízení',
        storageSectionDevicesTitle: 'Zařízení',
        devicesListTitle: 'Zařízení',
        dragAndDropMsg: 'Přetáhněte pin sem!',
        floorPlanLoadingError:
            'Při nahrávání půdorysu došlo k chybě. Prosím zkuste to znovu',
        locations: 'Místa',
        noLocations: 'Nejsou k dispozici žádná místa',
        searchUser: 'Hledat uživatele',
        pleaseSelectLocation: 'Prosím vyberte místo',
        sureNotToSaveLocation: 'Jste si jisti, že nechcete uložit nové místo',
        addSubLocation: 'Přidat dílčí umístění',
        addDevices: 'Přidat zařízení',
        removeLocation: 'Smazat místo',
        devices: 'Zařízení',
        network: 'Síť',
        networkDevice: 'Síťové zařízení',
        overview: 'Přehled',
        reports: 'Reporty',
        stats: 'Statistiky',
        shareInfo: 'Informace o sdílení',
        floorPlan: 'Plán podlaží',
        pictures: 'Obrázky',
        location: 'Lokalita',
        organisation: 'Organizace',
        version: 'Verze',
        status: 'Stav',
        share: 'Sdílet',
        batteryStatus: 'Stav baterie',
        actions: 'Akce',
        noDevicesAdded: 'Do této lokality nebyla přidána žádná nová zařízení',
        devicesOnLocation: 'Zařízení v této lokalitě',
        noDevicesSetupYet:
            'Na této lokalitě ještě nebyla nastavena žádná zařízení.',
        nameCanNotBeEmpty: 'Jméno nemůže být prázdné',
        address: 'Adresa',
        parentLocation: 'Nadřazená lokalita',
        noParentLocation: 'Žádná nadřazená lokalita',
        locationNotFound: 'Lokalita nenalezena',
        deviceName: 'Název zařízení',
        deviceSerial: 'Sériové číslo zařízení',
        event: 'Událost',
        time: 'Čas',
        reportsOnLocation: 'Zprávy o lokalitě',
        noReportsOnLocation: 'Na této lokalitě zatím nejsou žádné zprávy',
        locationStatistics: 'Statistiky lokality',
        noLocationStatistics: 'Pro tuto lokalitu zatím nejsou žádné statistiky',
        locationNotShared:
            'Tato lokalita není sdílena s žádným jiným uživatelem',
        sureRevokeShareAccessLocation:
            'Jste si jisti, že chcete odebrat přístup tomuto uživateli?',
        devicesAmount: 'Množství zařízení',
        noDevicesToAddFound: 'Nebyla nalezena žádná zařízení k přidání.',
        deleteLocationsModalText:
            'Jste si jisti, že chcete smazat tuto lokalitu? Všechny podlokality budou také smazány. Všechna zařízení budou přesunuta do skladu. Pokračovat?',
        dragNDropInfo: `Přetáhněte soubory sem nebo klikněte pro výběr souborů.`,
        dragNDropFiles: '(Můžete nahrávat soubory png, jpeg a pdf)',
        deleteFloorPlanModal: 'Jste si jisti, že chcete smazat plán podlaží?',
        toDeleteFloorPlanTypeIn:
            'Chcete-li smazat plán podlaží, zadejte toto číslo:',
        goToDevice: 'Přejít na zařízení',
        removeFromFloorPlan: 'Odstranit z plánu podlaží',
        noFloorPlan: 'Pro tuto lokalitu neexistuje žádný plán podlaží',
        addFloorPlan: 'Nahrát plán podlaží',
        addDevice: 'Přidat zařízení',
        addNewDevice: 'Přidat nové zařízení',
        devicesInThisLocation: 'Zařízení na této lokalitě',
        floorPlanBtns: {
            appearance: 'Vzhled',
            actions: 'Akce',
            add: 'Přidat zařízení',
            allFilters: 'Filtry',
            filter: 'Filtrovat zařízení',
            delete: 'Smazat plán podlaží',
            replace: 'Substituir planta baixa',
            serialLabel: 'Sériová čísla',
            nameLabel: 'Název zařízení'
        },
        locationsPath: 'Cesta k lokalitě',
        locationId: 'ID umístění',
        newLocation: '- Nová lokalita -',
        responsible: 'Odpovědný',
        onlyResponsibleLocations: 'Zvýraznit moje lokality (v stromu)',
        unlockMarkers: 'Odemknout značky',
        lockMarkers: 'Zamknout značky',
        responsibleTooltip:
            'Lokality, za které jste zodpovědný, budou označeny malou modrou tečkou',
        addResponsible: 'Přidat zodpovědného',
        add: 'Přidat',
        scanWithQr: 'Skenovat',
        allLocations: 'Všechny',
        myLocations: 'Moje lokality',
        userSearchError: 'Při hledání uživatelů došlo k chybě',
        getResponsiblesError:
            'Při načítání zodpovědných za tuto lokalitu došlo k chybě',
        addResponsibleError: 'Při pokusu přidat zodpovědného došlo k chybě',
        deleteResponsibleError: 'Při mazání zodpovědného došlo k chybě',
        getResponsibleLocationsError:
            'Při načítání lokalit pro zodpovědného uživatele došlo k chybě',
        userNotFound: 'Uživatel nebyl nalezen..',
        noLocationsForResponsible: 'Zatím nejsou přiřazeny žádné lokality.',
        assign: 'Přiřadit',
        contact: 'Kontaktní osoba',
        locationEmail: 'E-mail lokality',
        locationDetails: 'Detaily lokality (volitelné)',
        contactPhone: 'Telefon lokality',
        noFloorplan: 'Zatím nebyl nahrán žádný plán',
        selectFile: 'Vyberte soubor nebo sem soubor přetáhněte',
        uploadFloorplan: 'Nahrát plán',
        editFloorplan: 'Upravit plán',
        crop: 'Oříznout',
        rotate: 'Otočit',
        save: 'Uložit',
        somethingWentWrong: 'Jejda, něco se pokazilo',
        heatmap: 'Tepelná mapa',
        escalationLevels: 'Úrovně eskalace',
        level: 'Úroveň',
        sendAutomaticallyTriggered: 'Odesílání automaticky e-mailů',
        days: 'Dny',
        hours: 'Hodiny',
        afterTrapStatus:
            'Po tom, jak past přijala svůj stav a stav se nezměnil',
        afterTheTrapTriggered: 'po spuštění pasti se stav nezměnil.',
        eMailOfRecipient: 'E-mail příjemce',
        addLevel: 'Přidat úroveň',
        escalationModalSubTitle:
            'Zpráva bude přidána do e-mailu spolu s informacemi o zařízení a obrázkem půdorysu',
        locationsWithoutAddressLabel:
            'Následující místa nemají adresu, uložte si prosím adresu těchto míst:',
        locationsWithoutAddressAndWithoutCoordsLabel:
            'Následující místa mají adresu, ale nelze je zobrazit na mapě, protože adresa nebyla na mapě nalezena, ověřte prosím adresu místa',
        floorPlanPinCaution:
            'Doporučujeme restartovat zařízení, pokud jste ho přesunuli na nové místo',
        showCompletedTasks: 'Zobrazit dokončené úkoly',
        hideCompletedTasks: 'Skrýt dokončené úkoly',
        tasksAtThisLocation: 'Úkoly na tomto místě',
        createNewTask: 'Vytvořit nový úkol',
        tasks: 'Úkoly',
        tasksFetchFail: 'Nepodařilo se načíst úkoly',
        taskCreated: 'Úkol byl úspěšně vytvořen',
        taskCreateFail: 'Nepodařilo se vytvořit úkol',
        taskUpdated: 'Úkol byl úspěšně aktualizován',
        taskUpdateFail: 'Nepodařilo se aktualizovat úkol',
        taskDescriptionTooLong:
            'Popis úkolu je příliš dlouhý, je povoleno maximálně 1024 znaků',
        includeSubLocations: 'Zahrnout pod-lokace',
        last30Days: 'Posledních 30 dní',
        last7Days: 'Posledních 7 dní',
        clickOnThePFM: 'Klikněte na bod pro více informací',
        reportsAmount: 'Počet zpráv',
        settingsAndActions: 'Nastavení a akce',
        locationSettings: 'Nastavení umístění',
        locationActions: 'Akce umístění',
        baitSettings: 'Nastavení Jerry Bait',
        successWithAmountOfUpdatedDevices:
            'Úspěch! Počet aktualizovaných zařízení:',
        settingsAndActionsAreAppliedToAll:
            'Nastavení a akce založené na umístění se aplikují na všechna zařízení v tomto umístění.',
        settingsAndActionsAreNotAppliedToSL:
            'Nastavení a akce se neaplikují na podumístění a zařízení v podumístěních.',
        noSettingsConfiguredYet:
            'Pro toto umístění zatím nebyla nakonfigurována žádná nastavení.',
        selectSettingType: 'Vyberte typ nastavení',
        areYouSureYouWantToRemoveThisSetting:
            'Opravdu chcete odebrat toto nastavení?',
        resetTheActivityThreshold: 'Obnovit prahovou hodnotu aktivity',
        resetTheActivityThresholdDescr:
            'Obnovení prahové hodnoty aktivity vymaže počet aktivit pro vybrané období',
        locationBasedSettingsAndActions:
            'Nastavení a akce založené na umístění',
        lBasedConfirmReplaceBaitQuestion:
            'Potvrzením nastavíte datum poslední výměny návnady pro všechna zařízení v tomto umístění.',
        lBasedConfirmThresholdResetQuestion:
            'Potvrzením obnovíte aktivity pro všechna zařízení v tomto umístění. Bude nastavena nová prahová hodnota a aktivity budou obnoveny pro vybrané období.',
        lBasedSettingsAreAppliedYouCanNotEdit:
            'Hodnoty hmotnosti návnady a aktivity jsou nastaveny podle umístění. Chcete-li je změnit, otevřete nastavení umístění.',
        lBasedSettingsAreApplied:
            'Hodnoty hmotnosti návnady a aktivity jsou nastaveny podle umístění.',
        confirmPowerOffDescr:
            "Tímto potvrzujete, že jste vypnuli všechna zařízení v tomto umístění a nastavujete stav zařízení na 'Neaktivní'.",
        switchMMModeOnDescr:
            'Zapne režim údržby pro všechna zařízení v tomto umístění. V režimu údržby zařízení nemění svůj stav, nevytvářejí se zprávy a neodesílají se upozornění.',
        switchMMModeOffDescr:
            'Vypne režim údržby pro všechna zařízení v tomto umístění.',
        confirmMMModeOnDescr:
            'Režim údržby bude zapnut pro všechna zařízení v tomto umístění. V režimu údržby zařízení nemění svůj stav, nevytvářejí se zprávy a neodesílají se upozornění.',
        confirmMMModeOffDescr:
            'Režim údržby bude vypnut pro všechna zařízení v tomto umístění.'
    },
    devices: {
        noDeviceMoveHistoryMsg: 'Pro toto zařízení není žádná historie pohybu.',
        getDeviceMoveHistoryEx:
            'Došlo k chybě při načítání historie pohybu zařízení',
        assigned: 'Přiřazeno',
        allDevices: 'Všechna zařízení',
        details: 'Detaily',
        devices: 'Zařízení',
        location: 'Lokalita',
        organisation: 'Organizace',
        version: 'Verze',
        serialNr: 'Sériové číslo',
        name: 'Název',
        deviceSerial: 'Sériové číslo zařízení',
        description: 'Popis',
        operationModeLabel: 'Režim provozu',
        heartbeatCount: 'Množství stavových zpráv',
        mode: 'Režim',
        status: 'Stav',
        batteryStatus: 'Stav baterie',
        actions: 'Akce',
        noDevicesSetup: 'Nejsou nastavena žádná zařízení',
        noUserFromAnotherOrg:
            'Zatím neexistuje žádný uživatel z jiné organizace.',
        pleseAddUserFromAnotherOrg:
            'Přidejte prosím uživatele z jiné organizace.',
        inUserMgmt: 'v Správě uživatelů',
        chooseUserToShareWith: 'Vyberte uživatele, se kterým chcete sdílet',
        macAddress: 'MAC adresa',
        battery: 'Baterie',
        deviceIsNotFound: 'Zařízení nebylo nalezeno',
        nameIsTooShort: 'Jméno je příliš krátké',
        reset: 'Obnovit výrobní nastavení',
        resetTomStatus: 'Resetovat stav',
        reportCatch: 'Nahlásit úlovek',
        setOffline: 'Potvrdit vypnutí',
        heartbeatInterval: 'Interval srdečního tepu',
        occupancyRate: 'Obsazenost',
        triggerCount: 'Počet spuštění',
        triggeredSince: 'Spuštěno od',
        catchCount: 'Počet úlovků',
        traps: 'Pasti',
        noReportsNow: 'V současné době nejsou k dispozici žádné zprávy pro',
        noReportsForRange:
            'Pro tento časový interval nejsou k dispozici žádné zprávy pro',
        noReportsYet: 'Zatím nejsou k dispozici žádné zprávy',

        resetDescr: `Předchozí statistiky pro toto zařízení budou smazány. Navíc budou resetována následující nastavení: Název, Popis, Interval srdečního tepu. Zařízení bude nastaveno na stav "Neaktivní".`,
        resetDescrNote: `Vezměte na vědomí, že baterii budete muset resetovat zvlášť.`,
        reportCatchDescr: `Opravdu chcete nahlásit úlovek?`,
        reportCatchSelectReport:
            'Pro kterou z následujících zpráv chcete vytvořit zprávu o infestaci?',
        setOfflineDescr: `Tímto potvrzujete, že jste toto zařízení na místě vypnuli. Zařízení dostane stav "Neaktivní".`,
        resetBatteryDescr: `Tímto potvrzujete, že jste na místě vyměnili baterie tohoto zařízení. Počítadlo baterie se resetuje na 100%.`,
        resetBattery: `Potvrdit výměnu baterie`,
        resetTOMStatusDescr:
            'Stav tohoto TOM zařízení bude resetován na "Online".',
        online: 'Zařízení online',
        stock: 'Offline',
        warning: 'Varování',
        error: 'Kritické',
        filters: {
            warning: 'Varování',
            info: 'Zařízení online',
            inactive: 'Offline',
            critical: 'Kritické'
        },
        qrCode: 'QR kód',
        serialEmptyError: 'Zařízení bez sériového čísla',
        catchDescription: 'Popis úlovku',
        catchDescriptionMessage: 'Zde můžete přidat popis úlovku',
        wifiSetSuccess: 'Přihlašovací údaje WiFi byly úspěšně nastaveny',
        wifiSetFail: 'Nastavení přihlašovacích údajů WiFi selhalo',
        wifiPasswordMinLengthError: 'Musí být delší',
        wifiSSID: 'SSID WiFi',
        wifiPassword: 'Heslo WiFi',
        wifiSSIDMinLengthError: 'Nesmí být prázdné',
        wifiSignalStrength: 'Síla signálu',
        wifiSignalStrengthHover: 'Na základě posledního pulsování',
        wifiExcellent: 'Velmi dobrý',
        wifiGood: 'Dobrý',
        wifiLow: 'Nízký',
        wifiBad: 'Špatný',
        wifiUnknown: 'Neznámý',

        operationMode: {
            movement: 'Pohyb',
            snaptrap: 'Past',
            insect: 'Hmyz',
            bait: 'Návnada'
        },
        operationModeInsect: 'Hmyz',
        tom: 'TOM',
        jerry: 'JERRY',
        deviceTypes: {
            tom: 'TOM',
            jerry: 'JERRY',
            'jerry-lora': 'JERRY-LoRa',
            'tm01-1': 'TrapMe',
            trapsensor: 'TrapSensor',
            'jerry-bait-rat': 'JERRY-Bait-Rat'
        },
        deviceOperationMode: 'Režim zařízení',
        deviceType: 'Typ zařízení',
        routerType: 'Typ routeru',
        insectModeTooltip: 'Toto zařízení pracuje v režimu hmyz',
        snaptrapModeTooltip: 'Toto zařízení pracuje v režimu pasti',
        movementModeTooltip: 'Toto zařízení pracuje v režimu pohybu',
        baitModeTooltip: 'Toto zařízení pracuje v režimu návnady',
        rearmed: 'Přezbrojeno',
        inactive: 'Neaktivní',
        deviceIsInactive: 'Zařízení je neaktivní.',
        deviceStatuses: {
            0: 'Neaktivní',
            1: 'Aktivní',
            2: 'Chybí signál',
            3: 'Aktivováno',
            4: 'Slabá baterie',
            5: 'Hledání a připojování',
            6: 'Nestabilní spojení',
            7: 'Mírně napadené',
            8: 'Silně napadené',
            9: 'Falešná aktivace',
            10: 'Aktivita (Varování)',
            11: 'Aktivita (Kritické)'
        },
        deviceStatusDescription: {
            0: 'Zařízení je neaktivní.',
            1: 'Zařízení je online a funguje normálně.',
            2: 'Zdá se, že jsou problémy s připojením: Wifi spojení na pozici tohoto zařízení je nespolehlivé.',
            3: 'Past byla aktivována a vyžaduje ruční kontrolu.',
            4: 'Úroveň baterie v tomto zařízení je nízká. Prosím, vyměňte baterie.',
            5: 'Zařízení je v režimu majáku a lze jej lokalizovat.',
            6: 'Zdá se, že jsou problémy s připojením: Wifi spojení na pozici tohoto zařízení je nespolehlivé.',
            7: 'Uživatel nahlásil mírné napadení pro toto zařízení.',
            8: 'Uživatel nahlásil silné napadení pro toto zařízení.',
            9: 'Uživatel nahlásil falešné spuštění pasti pro toto zařízení.',
            10: 'Uživatel nahlásil aktivitu u tohoto zařízení.',
            11: 'Uživatel nahlásil kritickou aktivitu u tohoto zařízení.'
        },
        deviceStatusShortDescription: {
            0: 'Neaktivní',
            1: 'Aktivní',
            2: 'Chybí signál',
            3: 'Aktivováno',
            4: 'Slabá baterie',
            5: 'Hledání a připojování',
            6: 'Nestabilní spojení',
            7: 'Mírně napadené',
            8: 'Silně napadené',
            9: 'Falešná aktivace',
            10: 'Aktivita (Varování)',
            11: 'Aktivita (Kritické)'
        },
        deviceLastReportTypeShortDescription: {
            0: 'Online', // successfully_set_up
            1: 'Online', // restarted
            2: 'Aktivováno',
            3: 'Online', // rearmed
            '3-bait': 'Návnada k dispozici',
            4: 'Chybí signál',
            5: 'Mimo provoz',
            6: 'Hledání a připojování',
            11: 'Online', // online_again
            12: 'Neaktivní',
            13: 'Nestabilní spojení',
            15: 'Mírně napadené',
            16: 'Silně napadené',
            17: 'Falešná aktivace',
            18: 'Aktivita (Varování)',
            19: 'Aktivita (Kritické)',
            20: 'Úlovek',
            21: 'Aktivita zaznamenána',
            22: 'Práh aktivity dosažen',
            23: 'Nízká návnada',
            24: 'Práh aktivity dosažen a nízká návnada',
            25: 'Práh aktivity resetován'
        },
        changeOperationMode:
            'Zvolili jste jiný režim. Pro uplatnění změny vypněte a opět zapněte zařízení TOM.',
        pestControlSystemLabel: 'Systém proti škůdcům',
        pestControlSystemNotSelected: 'Nebylo vybráno',
        pestControlSystems: {
            1: 'AF-Box (Krysa)',
            2: 'nagtag (Myš)',
            3: 'nagtag (Krysa)',
            4: 'Kovový Tunel (Krysa)',
            5: 'SpeedBreak (Myš)',
            6: 'GSG (Myš)',
            7: 'Flexibilní Stativ',
            8: 'Heisenberg Detektor Švábů',
            9: 'Agrisense Lapač Molů',
            10: 'UV Lapač Much (libovolný)',
            11: 'GSG (Krysa)'
        },
        deviceActions: 'Akce zařízení',
        serialNumberSearchModal: {
            header: 'Hledat seznam sériových čísel',
            subHeader:
                'Zde můžete vložit seznam sériových čísel zařízení s každým sériovým číslem na nový řádek, následovně:',
            placeHolder: 'Sériová čísla'
        },
        tableConfigurationModal: {
            header: 'Konfigurace sloupců tabulky',
            subHeaderMainly: 'Hlavně používané',
            subHeaderAdditional: 'Další'
        },
        moveDevicesModal: {
            header: {
                1: 'Kam by se mělo přesunout?',
                2: 'Přesunout zařízení(y) na místo'
            },
            totalNumber: 'Celkový počet:'
        },
        configureTableLabel: 'Konfigurovat tabulku',
        history: 'Historie',
        move: 'Přesunout',
        pestControlSystem: 'Systém',
        transferMode: 'Režim přenosu',
        cellular: 'Mobilní',
        connectedGateway: 'LoRa gateway',
        gatewayNotFound: 'Gateway nenalezena',
        gatewayLastSignal: 'Poslední signál',
        notAssigned: 'Nepřiřazeno',
        moveDToL: 'Přesunout zařízení do umístění',
        youAreNotAbleToMoveTheseDevices:
            'Nemůžete přesunout tato zařízení, protože umístění, ve kterých se nacházejí, vám nejsou přiřazena nebo máte k nim pouze přístup pro čtení. Zkontrolujte prosím svou roli nebo kontaktujte správce vaší organizace.',
        devicesAmount: 'Počet zařízení',
        noDevicesYouCanMove:
            'Neexistují žádná zařízení, která byste mohli přesunout do jiného umístění z těch, která jste vybrali',
        devicesReadyToMove: 'Tato zařízení jsou připravena k přesunutí.',
        devicesSelected: 'Vybráno',
        moveToLocation: 'Přesunout do umístění',
        delete: 'Smazat',
        youAreNotAbleToDeleteTheseDevices:
            'Nemůžete smazat tato zařízení, protože umístění, ve kterých se nacházejí, vám nejsou přiřazena nebo nemáte oprávnění k jejich smazání. Zkontrolujte prosím svou roli nebo kontaktujte správce vaší organizace.',
        devicesRemovedFromOrg: 'Zařízení byla úspěšně odstraněna z organizace',
        deleteDevicesFromOrg: 'Odstranit zařízení z vaší organizace',
        noDevicesYouCanDelete:
            'Neexistují žádná zařízení, která byste mohli smazat',
        devicesReadyToDelete: 'Tato zařízení jsou připravena ke smazání.',
        areYouSureYouWantToDeleteDevices:
            'Jste si jisti, že chcete smazat zařízení? Zařízení budou odstraněna z vašeho účtu a již nebudou viditelná v seznamu zařízení.',
        devicesSwitchedOffSuccessfully: 'Zařízení byla úspěšně vypnuta',
        noDevicesYouCanSwitchOff:
            'Neexistují žádná zařízení, u kterých byste mohli potvrdit vypnutí',
        devicesReadyToSwitchOff: 'Tato zařízení jsou připravena k vypnutí.',
        areYouSureYouWantToConfirmSwitchOff:
            'Jste si jisti, že chcete potvrdit vypnutí těchto zařízení? Tímto potvrzujete, že jste zařízení vypnuli na místě. Zařízení dostanou status "Neaktivní"',
        devicesSwitchedOnMModeSuccessfully: 'Režim údržby byl úspěšně zapnut',
        noDevicesYouCanSwitchOnMMode:
            'Neexistují žádná zařízení, u kterých byste mohli zapnout režim údržby',
        forTheseDevicesYouCanSwitchOnMMode:
            'U těchto zařízení můžete zapnout režim údržby.',
        areYouSureYouWantToConfirmSwitchOnMMode:
            'Jste si jisti, že chcete zapnout režim údržby pro tato zařízení? V režimu údržby nevytvářejí se zprávy a neposílají se oznámení.',
        youAreNotAbleToSwitchOffTheseDevices:
            'Nemůžete vypnout tato zařízení, protože umístění, ve kterých se nacházejí, vám nejsou přiřazena nebo nemáte oprávnění k jejich aktualizaci. Zkontrolujte prosím svou roli nebo kontaktujte správce vaší organizace.',
        youAreNotAbleToSwitchOnMModeTheseDevices:
            'Nemůžete zapnout režim údržby pro tato zařízení, protože umístění, ve kterých se nacházejí, vám nejsou přiřazena nebo nemáte oprávnění k jejich aktualizaci. Zkontrolujte prosím svou roli nebo kontaktujte správce vaší organizace.',
        areYouSureConfirmReplacementOfBait:
            'Opravdu chcete potvrdit výměnu návnady?',
        areYouSureYouWantToResetTheActivityThreshold:
            'Opravdu chcete obnovit prahovou hodnotu aktivity?',
        baitMonitoring: 'Monitorování návnady',
        enablesOrDisablesBaitWeightTracking:
            'Aktivuje nebo deaktivuje monitorování návnady',
        activityAlertThreshold: 'Prahová hodnota aktivity',
        whenTheNotificationAlertShouldBeTriggered:
            'Při kolika aktivitách chcete obdržet upozornění?',
        per: 'za',
        hours: 'hodiny',
        days: 'dny',
        baitType: 'Typ návnady',
        whichBaitAreYouUsing: 'Jakou návnadu / hmotnost používáte?',
        calibration: 'Prahová hodnota návnady',
        notifiedWhenBaitWeightLowerThan:
            'Na jakou hmotnost byla podložka návnady kalibrována? Při této zbytkové hmotnosti obdržíte upozornění.',
        baitPad: 'Podložka návnady',
        replaceBait: 'Potvrdit výměnu návnady',
        resetsTheBaitStatusToAvailable: 'Nastaví čas poslední výměny návnady',
        lastReplacement: 'Poslední výměna návnady',
        baitLowCount: 'Celkový počet spotřeby návnady',
        activityCount: 'Celkový počet aktivit',
        activitiesThreshold: 'Prahová hodnota aktivity',
        last: 'poslední',
        lastThresholdReset: 'Poslední obnovení prahové hodnoty aktivity',
        activities: 'Aktivity',
        activitiesSummary: 'Souhrn aktivit',
        trackActivitiesInsights: 'Přehled aktivit',
        bait: 'Návnada',
        baitAvailable: 'Návnada dostupná',
        baitLow: 'Úroveň návnady nízká',
        baitStatusDebounceInfo:
            'Stavy „Úroveň návnady nízká“ a „Návnada dostupná“ se aktualizují až poté, co po dobu {{minutes}} minut nebyl na podložce návnady zaznamenán žádný pohyb. Při nastavování zařízení zapněte <bold>Režim údržby</bold>, aby se stav zobrazoval v reálném čase.',
        manufacturerAndType: 'Výrobce / Typ',
        overrideLocationSettings:
            'Použít pro toto zařízení samostatné hodnoty sledování',
        overrideLocationSettingsDescription:
            'Zapněte tuto možnost, pokud toto zařízení potřebuje jiné hodnoty hmotnosti návnady nebo aktivity než ostatní zařízení v tomto umístění. Tyto hodnoty zůstanou aktivní, dokud tuto možnost nevypnete nebo zařízení neresetujete.',
        deviceSettingsSource: 'Používá nastavení zařízení',
        monitoringValuesSetForLocation: 'Používá nastavení z',
        baitAndActivitySettings: 'Nastavení návnady a aktivity',
        locationSettingsOverrideMoveWarningTitle:
            'Zachovat samostatná nastavení?',
        locationSettingsOverrideMoveWarningText:
            'Jedno nebo více vybraných zařízení má vlastní nastavení hmotnosti návnady nebo aktivity. Po přesunutí tato nastavení v zařízeních zůstanou. Nastavení z nového umístění se nepoužijí.',
        locationSettingsOverrideMoveConfirm: 'Přesunout a zachovat nastavení'
    },
    simCards: {
        simCard: 'SIM karta',
        simCardSerialNumber: 'Číslo SIM karty',
        activate: 'Aktivovat',
        deactivate: 'Deaktivovat',
        addSimCardLabel: 'Přidat SIM kartu',
        addSimCardTooltipText:
            'Toto síťové zařízení nemá přiřazenu SIM kartu. Můžete ji přidat ručně',
        simCardEmptyError: 'Nemůže být prázdné',
        simCardNotValidIccidError: 'Neplatný formát SIM karty',
        pendingStatusText: 'Stav SIM karty se mění, může to trvat až 5 minut',
        standByStatusText:
            'SIM karta čeká na přenos dat a stane se aktivní, jakmile to udělá',
        billingDetails: {
            totalSimCardsText: 'Aktivovaná síťová zařízení',
            totalSimCardsTextItalic: '(Aktuální měsíc)',
            billing: 'Fakturace',
            tooltipText:
                'Částka bude automaticky odečtena z vašeho účtu poslední den každého měsíce',
            currencySymbol: '€'
        }
    },
    reports: {
        sentAutomatically: 'Odesláno automaticky',
        noSharingHistory: 'Nebyly zaslány žádné zprávy',
        sharingHistory: 'Zpráva byla odeslána',
        sharedBy: 'od',
        toEmails: 'na',
        ccEmails: 'cc',
        filterFrom: 'Od',
        filterTo: 'Do',
        allReports: 'Všechny zprávy',
        reports: 'Zprávy',
        deviceName: 'Název zařízení',
        deviceSerial: 'Sériové číslo zařízení',
        event: 'Událost',
        time: 'Čas',
        location: 'Umístění',
        organisation: 'Organizace',
        status: 'Stav',
        type: 'Typ',
        share: 'Sdílet',
        sendMessage: 'Poslat zprávu',
        message: 'Zpráva',
        cancle: 'Zruš',
        send: 'Odeslat',
        sendReport: 'Odeslat zprávu',
        emailSentSuccess: 'Email byl úspěšně odeslán',
        emailSentFail: 'Jejda, něco se pokazilo',
        on: ' na ',
        sentAt: 'Odesláno v: ',
        failToSend: 'Odeslání selhalo: ',
        mailMessageBegin: 'Vážený pane/paní,',
        mailMessageMainSection: 'zaznamenali jsme spuštění pasti ',
        mailMessageMainSection2: '',
        mailMessageMainSection3:
            'Prosím, co nejdříve zkontrolujte past na úlovek.',
        mailMessageEnd: 'S pozdravem ',
        mailMessageEnd2: 'FA. Fleschhut',
        noReportsYet: 'Zatím žádné zprávy',
        noReportsForRange: 'Žádné zprávy pro vybrané časové období',
        reportTime: 'Čas hlášení',
        evaluationTime: 'Čas hodnocení',
        reportTypes: {
            0: 'Úspěšně nastaveno',
            1: 'Restartováno',
            2: 'Aktivováno',
            3: 'Připraveno',
            '3-bait': 'Návnada k dispozici',
            4: 'Chybí signál',
            5: 'Mimo provoz',
            6: 'Hledání nyní',
            7: 'Hledání selhalo',
            8: 'Nastavení aktualizováno',
            9: 'Aktualizace úspěšná',
            10: 'Slabá baterie',
            11: 'Opět online',
            12: 'Vypnuto',
            13: 'Nestabilní spojení',
            14: 'Napadené',
            15: 'Mírně napadené',
            16: 'Silně napadené',
            17: 'Falešná aktivace',
            18: 'Aktivita (Varování)',
            19: 'Aktivita (Kritické)',
            20: 'Úlovek',
            21: 'Aktivita zaznamenána',
            22: 'Práh aktivity dosažen',
            23: 'Nízká návnada',
            24: 'Práh aktivity dosažen a nízká návnada',
            25: 'Práh aktivity resetován'
        },
        reportTypesDescription: {
            0: 'Zařízení bylo restartováno a nová Wifi data byla úspěšně přenesena.',
            1: 'Zařízení bylo restartováno.',
            2: 'Past byla aktivována a vyžaduje ruční kontrolu.',
            3: 'Pasti jsou připraveny a zařízení je připraveno na další úlovek.',
            '3-bait': 'Na podložce s návnadou je k dispozici návnada.',
            4: 'Mohou být problémy s připojením: Zařízení se během zvoleného intervalu heartbeat nedokázalo připojit k serveru.',
            5: 'Jsou problémy s připojením: Zařízení se během prodlouženého časového období nedokázalo připojit k serveru a vyžaduje ruční kontrolu na místě.',
            6: 'Zařízení je v režimu majáku a lze jej lokalizovat.',
            7: 'Zařízení nemohlo zahájit režim majáku.',
            8: 'Nastavení zařízení (např. interval heartbeat nebo provozní režim) bylo změněno.',
            9: 'Firmware zařízení byl úspěšně aktualizován.',
            10: 'Úroveň baterie v tomto zařízení je nízká. Prosím, vyměňte baterie.',
            11: 'Zařízení je zpět online, už nejsou žádné problémy s připojením.',
            12: 'Zařízení bylo vypnuto.',
            13: 'Zdá se, že jsou problémy s připojením: Wifi spojení na pozici tohoto zařízení je nespolehlivé.',
            14: 'Uživatel nahlásil napadení (úlovek) pro toto zařízení.',
            15: 'Uživatel nahlásil mírné napadení pro toto zařízení.',
            16: 'Uživatel nahlásil silné napadení pro toto zařízení.',
            17: 'U tohoto zařízení byla hlášena falešná aktivace.',
            18: 'Uživatel nahlásil aktivitu u tohoto zařízení.',
            19: 'Uživatel nahlásil kritickou aktivitu u tohoto zařízení.',
            20: 'Byl zjištěn úlovek. Nutná ruční kontrola.',
            21: 'Byla zjištěna aktivita',
            22: 'Byl dosažen nastavený práh aktivity',
            23: 'Hladina návnady je nízká',
            24: 'Byl dosažen nastavený práh aktivity a hladina návnady je nízká',
            25: 'Práh aktivity byl manuálně resetován'
        },
        info: 'Info',
        warning: 'Varování',
        critical: 'Kritické',
        infested: 'Napadené',
        infestedDescription: 'Zobrazit události napadení',
        catch: 'Úlovek',
        triggered: 'Spuštěno',
        triggeredDescription: 'Zobrazit spuštěné události',
        connectivity: 'Konektivita',
        connectivityDescription: 'Zobrazit konektivitu na zařízení',
        catchDescription: 'Popis úlovku',
        settings: 'Nastavení',
        at: ' v ',
        comments: 'Komentáře',
        edit: 'Upravit',
        delete: 'Smazat',
        save: 'Uložit',
        deleteConfirmation: 'Opravdu chcete smazat komentář?',
        addComment: '+ Přidat komentář',
        commentsAvailable: 'K tomuto hlášení existují komentáře',
        enterCommentPlaceholder: 'Zadejte komentář...',
        commentEmptyEx: 'Prosím, zadejte komentář',
        somethingWentWrong: 'Při pořizování snímků podlaží se něco pokazilo',
        exportDenyMsg:
            'Prosím, vyberte časový rozsah pro export menší než 3 měsíce. Můžete ho nastavit ve filtrech. Aktuální časový rozsah je pro export příliš velký.',
        changeRTToFT: 'Změnit typ zprávy na falešný spuštěč',
        changeRTToFTDescr:
            'Past je prázdná? Prosím přidejte komentář a volitelně přidejte obrázek pasti. Po potvrzení bude tato zpráva o úlovku změněna na zprávu o falešném spuštění',
        changeRTToCatch: 'Změnit typ zprávy na úlovek',
        changeRTToCatchDescr:
            'Je v pasti úlovek? Prosím přidejte komentář a volitelně přidejte obrázek pasti. Po potvrzení bude tato zpráva o falešném spuštění změněna na zprávu o úlovku'
    },
    userManagement: {
        userManagement: 'Správa uživatelů',
        users: 'Uživatelé',
        roles: 'Role',
        roleName: 'Název role',
        customer: 'Organizace',
        actions: 'Akce',
        createNew: 'Vytvořit nový',
        addFromAnotherOrg: 'Přidat z jiné organizace',
        noUsersFound: 'Nebyli nalezeni žádní uživatelé',
        emailIsEmpty: 'Email je prázdný',
        isNotEmail: ' není email',
        fillInEmail: 'Prosím, vyplňte email uživatele z jiné organizace.',
        onlyToYourOrg: 'Můžete přidat uživatele pouze do vaší organizace',
        chooseRole: 'Prosím, vyberte roli pro uživatele',
        verify: 'Ověřit',
        add: 'Přidat',
        whichOrgToCreateUser: 'V které organizaci chcete vytvořit uživatele?',
        create: 'Vytvořit',
        pickOrgToDeleteUser:
            'Prosím, vyberte organizaci, ze které chcete uživatele smazat',
        sureDeleteUser: 'Opravdu chcete smazat tohoto uživatele?',
        sureDeleteUsers: 'Opravdu chcete smazat tyto uživatele?',
        nameIsTooShort: 'Jméno je příliš krátké',
        emailIsNotCorrect: 'Email není správný',
        genPassword: 'Generovat heslo',
        changePassword: 'Změnit heslo',
        noRolesFound: 'Nebyly nalezeny žádné role',
        component: 'Komponenta',
        read: 'Číst',
        update: 'Aktualizovat',
        delete: 'Smazat',
        roleNotFound: 'Role nebyla nalezena',
        defaultRoles: {
            [DEFAULT_ROLES.traplinked_admin]: 'traplinked admin',
            [DEFAULT_ROLES.customer_admin]: 'Administrátor organizace',
            [DEFAULT_ROLES.viewer]: 'Prohlížeč',
            [DEFAULT_ROLES.management_user]: 'Uživatel managementu',
            [DEFAULT_ROLES.read_only_user]: 'Uživatel pouze pro čtení',
            [DEFAULT_ROLES.location_management_user]:
                'Uživatel správy lokality',
            [DEFAULT_ROLES.technician]: 'Technik'
        },
        youCanNotDeleteThisUser: 'Nemůžete smazat tohoto uživatele',
        youCanNotDeleteThisRole: 'Tuto roli nemůžete smazat',
        usersStillAssigned: 'Uživatelé jsou stále přiřazeni k této roli',
        usersAssignedTheRole:
            'K roli, kterou chcete odstranit, jsou stále přiřazeni uživatelé',
        reassignThatUsers:
            'Přeřaďte tyto uživatele na jinou roli, než ji odstraníte',
        deleteRoleConfirmation: 'Opravdu chcete tuto roli odstranit?',
        reassignAndDeleteModal: {
            header: 'Uživatelé mají stále přiřazenou tuto roli',
            textOne:
                'Existují stále uživatelé přiřazení k roli, kterou chcete smazat',
            textTwo:
                'Prosím, přiřaďte těmto uživatelům jinou roli, než tuto smažete'
        },
        internalUser: 'Interní uživatel',
        externalUser: 'Externí uživatel',
        createUserModalTitle: 'Vytvořit nového uživatele',
        createExternalTitle: 'Vytvořit externího uživatele',
        createInternalTitle: 'Vytvořit interního uživatele',
        userRalationStepTitle: 'Vyberte vztah uživatele',
        credentialsStepTitle: 'Přihlášení & Heslo',
        createRoleStepTitle: 'Vytvořit vlastní roli',
        selectRoleStepTitle: 'Vyberte roli pro uživatele',
        selectLocationsStepTitle: 'Vyberte lokality',
        reviewStepTitle: 'Závěrečná kontrola',
        nextStep: 'Další krok',
        stepBack: 'Krok zpět',
        completeBtn: 'Dokončit',
        backToDefaultRoles: 'Zpět na výchozí role',
        userRalationOptionName: {
            [USER_RELATIONS.internal]: 'Interní',
            [USER_RELATIONS.external]: 'Externí'
        },
        userRalationOptionDescription: {
            [USER_RELATIONS.internal]:
                'Nový uživatelský účet pro osobu, která pracuje ve vaší organizaci, vhodné pro vašeho zaměstnance, který dosud nemá účet v systému traplinked',
            [USER_RELATIONS.external]:
                'Nový uživatelský účet / přístup k vaší organizaci od externí organizace, vhodný pro dodavatele, kteří dosud nemají uživatelský účet nebo už jeden mají'
        },
        firstName: 'Jméno',
        lastName: 'Příjmení',
        password: 'Heslo',
        customerName: 'Název zákazníka',
        userRelationExplanation: {
            [RELATIONS.internal]:
                'Uživatel s tímto emailem již existuje ve vaší organizaci jako interní',
            [RELATIONS.externalIn]:
                'Uživatel s tímto emailem již existuje ve vaší organizaci jako externí',
            [RELATIONS.externalOut]:
                'Totoho uživatele můžete do organizace přidat pouze jako externího. Chcete pokračovat?',
            [RELATIONS.nonexistent]: ''
        },
        roleNames: {
            [DEFAULT_ROLES.customer_admin]: 'Administrátor',
            [DEFAULT_ROLES.viewer]: 'Prohlížeč',
            [DEFAULT_ROLES.management_user]: 'Manažer',
            [DEFAULT_ROLES.technician]: 'Technik',
            [CUSTOM_ROLE]: 'Vlastní'
        },
        roleDescription: {
            [DEFAULT_ROLES.customer_admin]:
                'Plný rozsah oprávnění v systému: může spravovat lokality, zařízení, uživatele a zbytek',
            [DEFAULT_ROLES.viewer]:
                'Nemá přístup k správě uživatelů, může pouze číst a zobrazovat přiřazené lokality, vidět stav zařízení, zprávy z přiřazených lokalit',
            [DEFAULT_ROLES.management_user]:
                'Může vytvářet a spravovat lokality, ale nemůže je mazat, může spravovat zařízení, zprávy, může spravovat uživatele, ale nemůže je mazat',
            [DEFAULT_ROLES.technician]:
                'Nemá přístup k správě uživatelů, může vytvářet, spravovat a mazat přiřazené lokality, může spravovat zařízení a zprávy z přiřazených lokalit',
            [CUSTOM_ROLE]: 'Přizpůsobitelná role'
        },
        createNewCustomrole: '+ Vytvořit novou vlastní roli',
        selectExistingCustomRole: 'Vyberte existující vlastní roli',
        deselectAllLocations: 'Zrušit výběr všech',
        selectAllLocations: 'Vybrat vše',
        showTheUserInTheList: 'zobrazit uživatele v seznamu',
        youCanProceedWithRoleSelection:
            'Můžete pokračovat ve výběru role pro tohoto externího uživatele',
        sendInvitationMail: 'Odeslat pozvánku e-mailem',
        invitationModalText:
            'Jste si jisti, že chcete tomuto uživateli zaslat pozvánku?'
    },
    sharing: {
        sharing: 'Sdílení',
        chooseUsers: 'Vyberte uživatele',
        chooseItems: 'Vyberte položky k sdílení',
        confirmAndShare: 'Potvrdit a sdílet',
        organisation: 'Organizace',
        noUsersToShare:
            'Momentálně nejsou přidáni žádní uživatelé z jiné organizace.',
        pleaseAddUsers: 'Prosím, přidejte uživatele z jiné organizace',
        userMgmt: 'Správa uživatelů',
        noUsersLeft: 'Nezbyli žádní uživatelé k výběru',
        noUsersSelected: 'Zatím nebyli vybráni žádní uživatelé pro sdílení',
        locations: 'Lokality',
        devices: 'Zařízení',
        reports: 'Zprávy',
        serialNr: 'Sériové č.',
        noDevicesToShare: 'Momentálně nejsou k sdílení žádná zařízení',
        noDevicesLeft: 'Nezbyla žádná zařízení k výběru',
        noDevicesSelected: 'Zatím nebyla vybrána žádná zařízení',
        noReportsToShare: 'Momentálně nejsou k sdílení žádné zprávy',
        noReportsLeft: 'Nezbyly žádné zprávy k výběru',
        noReportsSelected: 'Zatím nebyly vybrány žádné zprávy',
        address: 'Adresa',
        noLocationsToShare: 'Momentálně nejsou k sdílení žádné lokality',
        contactSupport: 'Pokud vidíte tuto zprávu, kontaktujte prosím podporu',
        noLocationsLeft: 'Nezbyly žádné lokality k výběru',
        noLocationsSelected: 'Zatím nebyly vybrány žádné lokality',
        willBeSharedWith: 'Bude sdíleno s:',
        successShare: 'Úspěšně sdíleno'
    },
    detachedSharing: {
        noDataToShare: 'Momentálně nejsou k dispozici žádná data k sdílení',
        chooseUsers: 'Vyberte uživatele',
        chooseItems: 'Vyberte položky k sdílení',
        confirmAndShare: 'Potvrdit a sdílet',
        noDevicesSetupYet:
            'Na tomto místě dosud nebyla nastavena žádná zařízení.',
        devicesSelected: 'Vybraná zařízení',
        locationsSelected: 'Vybrané lokality',
        selected: 'Vybráno',
        shareWithUsers: 'Sdílet s uživateli',
        existingFromAnotherOrg: 'přidané z jiné organizace',
        byEmailFromAnotherOrg: 'e-mailem',
        noUsersToShare:
            'Momentálně nejsou přidáni žádní uživatelé z jiné organizace. Můžete sdílet e-mailem.',
        usersSelected: 'Vybraní uživatelé',
        plsTypeInEmail: 'Zadejte prosím platnou e-mailovou adresu',
        chooseRole: 'Vyberte prosím roli',
        addUsersEmails: 'Přidejte e-mailovou adresu uživatelů',
        location: 'Lokalita',
        device: 'Zařízení',
        serialNr: 'Sériové č.',
        dataForSharing: 'Data pro sdílení',
        willBeSharedWith: 'Bude sdíleno s',
        locationsPath: 'Cesta k lokalitě',
        nothingFound: 'Nic nenalezeno'
    },
    settings: {
        faq: 'ČKD',
        language: 'Jazyk',
        settings: 'Nastavení',
        logout: 'Odhlásit se',
        emailNotificationsEnabled: 'E-mailové upozornění',
        pushNotificationsEnabled: 'Push upozornění',
        smsNotificationsEnabled: 'SMS upozornění',
        trapsTriggeredNotificationsEnabled: 'Zařízení aktivováno',
        trapsInactiveemailNotificationsEnabled: 'Zařízení není aktivní',
        batteryEmptyNotificationsEnabled: 'Nízký stav baterie',
        batterySetupNotificationsEnabled: 'Zařízení bylo nastaveno',
        trapOnlineNotificationsEnabled: 'Zařízení je zpět online',
        unstableConnectionNotificationsEnabled:
            'Zařízení má nestabilní spojení',
        baitLowNotificationsEnabled: 'Zařízení má nízkou úroveň návnady',
        activityThresholdReachedNotificationsEnabled:
            'Zařízení dosáhlo prahové hodnoty aktivity',
        baitLowAndActivityThresholdReachedNotificationsEnabled:
            'Zařízení má nízkou úroveň návnady a dosáhlo prahové hodnoty aktivity',
        acceptSharedData: 'Aktualizovat sdílená data',
        notificationsChannels: 'Typy upozornění',
        notificationsEvents: 'Upozornění',
        nameIsTooShort: 'Jméno je příliš krátké',
        phoneNumberErr: 'Telefonní číslo není platné',
        organisationPhoneNumberErr: 'Telefonní číslo organizace není platné',
        reportBug: 'Nahlásit chybu',
        viewOurRoadmap: 'Podívejte se na náš plán',
        voteOnNewFeatures: 'Hlasování o nových funkcích',
        termsOfService: 'Podmínky služby',
        termsConditions: 'Podmínky a pravidla',
        privacyPolicy: 'Zásady ochrany osobních údajů',
        simCards: 'SIM karty',
        billingPortal: 'Facturació',
        portalError: 'Error en carregar el portal de facturació de Stripe'
    },
    login: {
        emailIsRequired: 'E-mail je nutný pro přihlášení',
        passwordIsRequired: 'Heslo je nutné pro přihlášení',
        forgotPassword: 'Zapomněli jste heslo?',
        signIn: 'Přihlásit se',
        newInTraplinked: 'Nový zákazník? Prosím, registrujte se.'
    },
    twoFactor: {
        title: 'Dvoufaktorové ověření',
        helperText: 'Zadejte 6místný kód, který jsme odeslali na váš e-mail',
        verify: 'Ověřit',
        backToLogin: 'Zpět na přihlášení'
    },
    resetPassword: {
        resetPassword: 'Resetovat heslo',
        backToLogin: 'Zpět na přihlášení',
        goToLogin: 'Přejít na přihlášení',
        passwordIsTooShort: 'Heslo je příliš krátké',
        passwordsDoNotMatch: 'Hesla se neshodují'
    },
    register: {
        nameIsTooShort: 'Jméno je příliš krátké',
        emailIsNotCorrect: 'E-mail není správný',
        passwordIsTooShort: 'Heslo je příliš krátké',
        passwordsDoNotMatch: 'Hesla se neshodují',
        registerUser: 'Registrovat uživatele',
        haveAlreadyUser: 'Už máte účet? Prosím, přihlašte se.',
        pleaseEnterOrgName: 'Zadejte název vaší organizace, je vyžadován',
        orgName: 'Název organizace',
        registerOrg: 'Registrovat organizaci',
        everythingIsReady:
            'Váš nový uživatel a nová organizace jsou připraveni, nyní se můžete přihlásit',
        goToLogin: 'Přejít na přihlášení',

        registerYourOrganization: 'Zaregistrujte svou organizaci',
        youAreAPestController:
            'Jste kontrolor škůdců a chcete zaregistrovat svou organizaci',
        alreadyHaveAnAccount: 'Už máte účet?',
        login: 'LPřihlaste se',
        or: 'Nebo na',
        joinAnExistingOrganization: 'Připojit se k existující organizaci?',
        accessYourOrganization:
            'Pokud jste technik nebo člen týmu a chcete získat přístup do své organizace, požádejte správce, aby vás pozval.',
        notSureWhoYourAdmin:
            'Nejste si jisti, kdo je váš Admin, nebo se potýkáte s problémy? Obraťte se na náš tým podpory a požádejte o pomoc.'
    },
    apiKeys: {
        apiKeys: 'API klíče',
        apiKey: 'API klíč',
        viewDocs: 'View REST docs',
        copied: 'Zkopírováno',
        failedToCopy: 'Kopírování se nezdařilo',
        createNew: 'Vytvořit nový',
        expires: 'Vyprší',
        noApiKeysFound: 'Nebyly nalezeny žádné API klíče',
        plsProvideDescr: 'Zadejte popis API klíče',
        deleteKeyDescr:
            'Pokud smažete tento API klíč, přístup k datům prostřednictvím tohoto API klíče nebude možný. Opravdu chcete tento API klíč smazat?',
        viewKeyDescr:
            'Zadejte API klíč do softwaru třetí strany, aby mohl zobrazovat data z vašeho zařízení. Pokud výrobce nabízí odpovídající funkci, můžete také naskenovat QR kód pro zadání API klíče.'
    },
    integrations: {
        integrations: 'Integrace',
        documentationTools: 'Dokumentační nástroje',
        apiKeys: 'API klíče',
        pestsoft: 'Pestsoft',
        debuxx: 'DEBUXX',
        pestscan: 'Pestscan',
        pestscanPcoId: 'Pestscan PCO ID',
        username: 'Uživatelské jméno',
        enterPassword: 'Zadejte heslo',
        credentialsRequired:
            'Zadejte a uložte přihlašovací údaje pro dokončení připojení.',
        pestscanPcoIdRequiredWhenEnabled:
            'PCO ID je vyžadováno, když je Pestscan zapnutý.',
        debuxxHint: {
            toggle: 'Jak získat tyto přihlašovací údaje?',
            title: 'Vytvořit API uživatele v Debuxx',
            body: 'Administrátoři mohou v Debuxx v **Einstellungen → Erweiterungen** vytvořit nového API uživatele zadáním uživatelského jména a hesla. Hodnoty pak zkopírujte sem pro připojení.',
            support:
                'Stále potřebujete pomoc? Pokud máte další dotazy ohledně vytvoření nebo získání těchto přihlašovacích údajů, obraťte se na podporu Debuxx.'
        },
        pestscanHint: {
            toggle: 'Jak získat své PCO ID?',
            title: 'Vytvořit profil PC40 v Pestscan',
            steps: {
                1: 'V hlavní navigační liště přejděte přes ozubené kolo na **General Settings**.',
                2: 'Z nabídky vyberte **Permanent Monitoring**.',
                3: 'Otevřete kartu **Profiles** a klikněte na **New**.',
                4: 'Nastavte **Description** na něco srozumitelného, například PC40.',
                5: 'Nastavte **Type** na PC40.',
                6: 'Klikněte na **Save**.',
                7: 'Zkopírujte výsledné **PCO ID** a vložte jej sem.'
            },
            support:
                'Stále potřebujete pomoc? Pokud máte další dotazy ohledně získání PCO ID, obraťte se na podporu Pestscan.'
        },
        settingsUpdated: 'Nastavení integrací bylo aktualizováno',
        settingsUpdateFailed: 'Nepodařilo se aktualizovat nastavení integrací',
        loadFailed: 'Nepodařilo se načíst nastavení integrací',
        summaryTitle: 'Přehled integrací a API',
        apiKeysCount: 'API klíče',
        webhooks: 'Webhooky',
        webhooksTab: {
            title: 'Webhooky',
            viewDocs: 'Zobrazit dokumentaci webhooků',
            createWebhook: 'Vytvořit webhook',
            editWebhook: 'Upravit webhook',
            deleteWebhook: 'Smazat webhook',
            confirmDeleteWebhook:
                'Webhook bude trvale smazán. Tuto akci nelze vrátit zpět.',
            noWebhooksFound: 'Zatím žádné webhooky',
            emptyBody:
                'Webhooky doručují události zařízení v reálném čase na vaše endpointy. Vytvořte jeden a začněte přijímat data.',
            editorSubtitle:
                'Webhooky doručují události zařízení v reálném čase',
            webhookCreated: 'Webhook byl vytvořen',
            webhookUpdated: 'Webhook byl aktualizován',
            webhookDeleted: 'Webhook byl smazán',
            createFailed: 'Nepodařilo se vytvořit webhook',
            updateFailed: 'Nepodařilo se aktualizovat webhook',
            deleteFailed: 'Nepodařilo se smazat webhook',
            loadFailed: 'Nepodařilo se načíst webhooky',
            statusEnabled: 'Aktivní',
            statusDisabled: 'Neaktivní',
            saveChanges: 'Uložit změny',
            cancel: 'Zrušit',
            never: '--',
            fields: {
                status: 'Stav',
                name: 'Název',
                description: 'Popis',
                endpoint: 'URL',
                webhookType: 'Typ',
                requestMethod: 'Metoda',
                reasons: 'Typy hlášení',
                reasonSingular: 'typ hlášení',
                reasonPlural: 'typy hlášení',
                reasonsTotalSuffix: 'k dispozici',
                isEnabled: 'Aktivní',
                isEnabledHint:
                    'Pokud je zapnuto, doručují se hlášení odpovídající vybraným typům.',
                headers: 'Hlavičky',
                lastResponse: 'Poslední odpověď',
                lastResponseCode: 'Kód poslední odpovědi',
                lastRequestTimestamp: 'Poslední požadavek'
            },
            placeholders: {
                name: 'Můj webhook',
                endpoint: 'https://example.com/webhooks/traplinked',
                description: 'K čemu tento webhook slouží?',
                reasonsEmpty: 'Vyberte jeden nebo více typů hlášení…'
            },
            headers: {
                keyHeader: 'Klíč',
                valueHeader: 'Hodnota',
                keyPlaceholder: 'např. Authorization',
                valuePlaceholder: 'Hodnota',
                addRow: 'Přidat hlavičku',
                removeRow: 'Odebrat hlavičku',
                maskedHint: '•••••• pro přepsání zadejte znovu',
                renamedHint: 'Přejmenováno — zadejte hodnotu znovu',
                versionRequired: 'Povinné',
                versionLatestHint: 'nejnovější je',
                versionLatestSuffix: 'nejnovější',
                empty: 'Zatím žádné vlastní hlavičky. Přidejte jednu pro autentizaci vašich požadavků.'
            },
            validation: {
                nameRequired: 'Název je povinný',
                endpointRequired: 'URL je povinná',
                reasonsRequired: 'Vyberte alespoň jeden typ hlášení',
                headerKeyRequired: 'Klíč hlavičky je povinný',
                headerValueRequired: 'Hodnota hlavičky je povinná',
                headerKeyDuplicate: 'Klíče hlaviček musí být jedinečné',
                versionReserved:
                    'traplinked-Version se nastavuje výše, ne jako vlastní hlavička'
            },
            reasonGroupLabels: {
                device: 'Stav zařízení',
                trap: 'Hlášení pasti',
                image: 'Obrázky',
                heartbeat: 'Heartbeat',
                activity: 'Aktivita a návnada'
            },
            reasonLabels: {
                image_received: 'Obrázek přijat',
                image_ai_processed: 'Obrázek zpracován AI',
                heartbeat_received: 'Heartbeat přijat',
                trap_triggered: 'Past spuštěna',
                battery_low: 'Slabá baterie',
                catch_detected: 'Odchyt detekován',
                rearmed: 'Znovu nastraženo',
                offline: 'Offline',
                online: 'Online',
                configured: 'Nakonfigurováno (počáteční tovární nastavení)',
                maintained: 'Provedena údržba (tovární servis)',
                switched_off: 'Vypnuto',
                catch_reported: 'Odchyt nahlášen',
                false_triggering: 'Falešné spuštění',
                activity_noticed: 'Detekována aktivita',
                activity_threshold_reached: 'Dosažen limit aktivity',
                bait_low: 'Nízký stav návnady',
                activity_threshold_reached_and_bait_low:
                    'Dosažen limit aktivity a nízký stav návnady'
            },
            typeLabels: {
                traplinked: 'traplinked',
                rentokil_tom_images: 'Rentokil TOM obrázky',
                pestsoft: 'Pestsoft',
                axinsectai: 'AxInsectAI'
            },
            methodLabels: {
                post: 'POST',
                put: 'PUT',
                patch: 'PATCH',
                get: 'GET',
                delete: 'DELETE'
            }
        },
        billingNotice:
            'Aktivní integrace a API klíče stojí 0,10 € za zařízení měsíčně u zařízení, která od začátku měsíce alespoň jednou odeslala signál. Zařízení vytvořená 31.12.2024 nebo dříve jsou osvobozena.',
        openBillingDashboard: 'Otevřít fakturační dashboard',
        billingDataLoadFailed:
            'Nepodařilo se načíst přehled integrací a fakturace',
        billingModalTitle: 'Tato aktivace ovlivní vaši fakturaci',
        billingModalIntro:
            'Aktivace jakékoli integrace, API klíče nebo webhooku spouští fakturaci pro vaši organizaci. Podrobnosti:',
        billingModalRulePrice: 'Cena: 0,10 € za zařízení měsíčně',
        billingModalRuleHeartbeat:
            'Účtují se pouze zařízení, která během měsíce odeslala alespoň jeden signál (heartbeat)',
        billingModalRuleGrandfathered:
            'Zařízením, která jsou online od nebo před 31.12.2024, nevznikají žádné náklady',
        billingModalConfirm: 'Souhlasím, zapnout',
        billingModalCancel: 'Zrušit'
    },
    /* subscriptions: {
        tryIt: 'Vyzkoušet',
        tryPremiumTrial:
            'Vyzkoušejte všechny prémiové funkce zdarma na 3 měsíce.',
        thisIsPremium: 'Toto je prémiová funkce',
        subscriptions: 'Předplatné',
        pricingPlans: 'Cenové plány',
        description: 'Jednoduché, transparentní ceny, které s vámi rostou.',
        billedMonthly: 'Fakturace měsíčně',
        billedYearly: 'Fakturace ročně',
        monthlyBilled: 'Měsíčně fakturované',
        annualBilling: 'Roční fakturace',
        yourCurrentPlan: 'Váš současný plán',
        upgradeNow: 'Upgradovat nyní',
        subscribeNow: 'Předplatit si nyní',
        premiumSupport: 'Prémiová podpora',
        api: 'API',
        billingInformation: 'Fakturační údaje',
        addressInputLabel: 'Ulice & číslo domu',
        zipCodeInputLabel: 'PSČ',
        cityInputLabel: 'Město',
        countryInputLabel: 'Země',
        vatNumberInputLabel: 'DIČ',
        subscriptionsModalTitle: 'Předplatné úspěšně aktivováno',
        thanksForYourTrust: 'Děkujeme za vaši důvěru!',
        youCanAccessAllPremiumFeaturesNow:
            'Nyní máte přístup ke všem prémiovým funkcím',
        cancelSubscriptionModalTitle: 'Jste si jistý?',
        cancelSubscriptionModalText:
            'Po skončení vašeho fakturačního cyklu ztratíte všechny prémiové funkce.',
        successModalButtonText: 'Začít',
        companyNameRequireValidationMessage:
            'Název společnosti je vyžadován',
        companyNameMinLengthValidationMessage:
            'Název společnosti je příliš krátký',
        companyNameMaxLengthValidationMessage:
            'Název společnosti je příliš dlouhý',
        companyIsValidValidationMessage: 'Název společnosti je neplatný',
        nameRequireValidationMessage: 'Jméno je vyžadováno',
        nameMinLengthValidationMessage: 'Jméno je příliš krátké',
        nameMaxLengthValidationMessage: 'Jméno je příliš dlouhé',
        nameIsValidValidationMessage: 'Jméno je neplatné',
        lastNameRequireValidationMessage: 'Příjmení je vyžadováno',
        lastNameMinLengthValidationMessage: 'Příjmení je příliš krátké',
        lastNameMaxLengthValidationMessage: 'Příjmení je příliš dlouhé',
        lastNameIsValidValidationMessage: 'Příjmení je neplatné',
        addressRequireValidationMessage:
            'Ulice a číslo domu jsou vyžadovány',
        addressIsValidValidationMessage:
            'Neplatný formát ulice a čísla domu',
        zipCodeRequireValidationMessage: 'PSČ je vyžadováno',
        zipCodeIsValidValidationMessage: 'Neplatné PSČ',
        cityRequireValidationMessage: 'Město je vyžadováno',
        cityIsValidValidationMessage: 'Neplatné jméno města',
        countryRequireValidationMessage: 'Země je vyžadována',
        countryIsValidValidationMessage: 'Neplatný název země',
        vatNumberRequireValidationMessage: 'DIČ je vyžadováno',
        vatNumberIsValidValidationMessage: 'DIČ je neplatné',
        cancelSubscription: 'Zrušit předplatné',
        subscriptionCanceled: 'Předplatné zrušeno',
        cancelledValidUntil: 'Zrušeno - platné do',
        tryItForFree: 'Vyzkoušejte zdarma',
        basicCard: {
            basic: 'Základní',
            free: 'Zdarma',
            manageDevices: 'Správa zařízení',
            pushNotifications: 'Push notifikace',
            reports: 'Zprávy',
            basicChatAndEmailSupport: 'Základní podpora chatem a e-mailem',
        },
        premiumCard: {
            premium: 'Prémiové',
            accessToAllBasicFeatures: 'Přístup ke všem základním funkcím',
            apiKeys: 'API klíče',
            analogDevices: 'Analogová zařízení',
            dataExport: 'Export dat (CSV, PDF, Excel)',
            floorplans: 'Plány podlaží',
            notifications: 'Notifikace',
            catchReport: 'Hlášení o úlovku',
            aiTom: 'AI analýza TOM obrázků',
        },
        premiumSupportCard: {
            phoneSupport: 'Podpora po telefonu 24/7',
        },
    }, */
    sagasMsgs: {
        /* common */
        getReportSharingHistoryEx: 'Chyba při získávání historie sdílení zpráv',
        commonLoadingError: 'Něco se pokazilo. Zkuste to prosím znovu',
        /* login */
        loginEx: 'Přihlašovací údaje jsou nesprávné',
        loginWithTsEx: 'Došlo k chybě, obraťte se na podporu.',
        sessionEx: 'Vaše relace vypršela',
        verify2faEx: 'Neplatný nebo vypršelý kód. Zkuste to prosím znovu.',
        updataProfileRes: 'Profil byl aktualizován.',
        updataProfileEx: 'Chyba při aktualizaci profilu',
        pswdChangeRes: 'Heslo bylo změněno.',
        pswdChangeEx:
            'Došlo k chybě při změně hesla, ujistěte se, že staré heslo je správné.',
        forgotPswdRes:
            'Na vaši e-mailovou adresu byl odeslán odkaz pro resetování hesla.',
        forgotPswdEx: 'Došlo k chybě při vyžádání resetování hesla',
        resetPswdRes: 'Heslo bylo úspěšně změněno, nyní se můžete přihlásit.',
        resetPswdEx:
            'Došlo k chybě, zkuste prosím znovu resetovat heslo na přihlašovací stránce',
        saveLocaleEx: 'Při pokusu o uložení nastavení jazyka došlo k chybě.',
        /* customers */
        getCustomersEx: 'Při načítání zákazníků došlo k chybě',
        getCustomerEx: 'Při načítání zákazníka došlo k chybě',
        updateCustomerEx: 'Při aktualizaci zákazníka došlo k chybě',
        updateCustomerRes: 'Zákazník byl úspěšně aktualizován',
        getSoftwarePlansEx: 'Při načítání plánů software došlo k chybě',
        /* locations */
        getLocationsEx: 'Při načítání lokací došlo k chybě',
        getLocationEx: 'Při načítání lokace došlo k chybě',
        updateLocationRes: 'Lokace byla úspěšně aktualizována',
        updateLocationEx: 'Při aktualizaci lokace došlo k chybě',
        createLocationRes: 'Lokace byla úspěšně vytvořena',
        createLocationEx: 'Při vytváření lokace došlo k chybě',
        deleteLocationRes: 'Lokace byla úspěšně odstraněna',
        deleteLocationEx: 'Při odstraňování lokace došlo k chybě',
        shareLocationRes: 'Úspěšně sdíleno',
        shareLocationEx: 'Při sdílení polohy došlo k chybě',
        getLocationDevicesEx: 'Při získávání zařízení umístění došlo k chybě',
        getLocationReportsEx: 'Při získávání zpráv umístění došlo k chybě',
        getLocationSharedUsersEx:
            'Při získávání informací o sdílení umístění došlo k chybě',
        getAvailableDevicesEx:
            'Při načítání dostupných zařízení pro přidání došlo k chybě',
        moveDevicesRes: 'Zařízení byla úspěšně přidána do umístění',
        moveDevicesEx: 'Při přidávání zařízení do umístění došlo k chybě',
        createFloorPlanRes: 'Plán podlaží byl úspěšně vytvořen',
        createFloorPlanEx: 'Při vytváření plánu podlaží došlo k chybě',
        getFloorPlanEx: 'Při načítání plánu podlaží došlo k chybě',
        deleteFloorPlanRes: 'Plán podlaží byl úspěšně smazán',
        deleteFloorPlanEx: 'Při mazání plánu podlaží došlo k chybě',
        getFPAvailableDevicesEx:
            'Při načítání dostupných zařízení pro přidání do plánu podlaží došlo k chybě',
        addDevicesToFPEx:
            'Při přidávání zařízení do plánu podlaží došlo k chybě',
        updateFPDeviceEx:
            'Při aktualizaci zařízení plánu podlaží došlo k chybě',
        deleteFPDeviceEx: 'Při mazání zařízení z plánu podlaží došlo k chybě',
        /* traps */
        // getTrapsEx: 'Při načítání pastí došlo k chybě',
        // getTrapEx: 'Při načítání pasti došlo k chybě',
        // updateTrapRes: 'Past byla úspěšně aktualizována',
        // updateTrapEx: 'Při aktualizaci pasti došlo k chybě',
        // createTrapRes: 'Past byla úspěšně vytvořena',
        // createTrapEx: 'Při vytváření pasti došlo k chybě',
        // deleteTrapRes: 'Past byla úspěšně odstraněna',
        // deleteTrapEx: 'Při odstraňování pasti došlo k chybě',
        /* reports */
        // getReportsEx: 'Při načítání zpráv došlo k chybě',
        // getReportEx: 'Při načítání zprávy došlo k chybě',
        // updateReportRes: 'Zpráva byla úspěšně aktualizována',
        // updateReportEx: 'Při aktualizaci zprávy došlo k chybě',
        // createReportRes: 'Zpráva byla úspěšně vytvořena',
        // createReportEx: 'Při vytváření zprávy došlo k chybě',
        // deleteReportRes: 'Zpráva byla úspěšně odstraněna',
        // deleteReportEx: 'Při odstraňování zprávy došlo k chybě',
        /* devices */
        getDevicesEx: 'Při načítání zařízení došlo k chybě',
        getDeviceEx: 'Při načítání zařízení došlo k chybě',
        getDeviceReportsEx: 'Při načítání zpráv zařízení došlo k chybě',
        shareDevicesRes: 'Úspěšně sdíleno',
        shareDevicesEx: 'Při sdílení zařízení došlo k chybě',
        resetDeviceRes: 'Zařízení bylo úspěšně resetováno',
        resetDeviceEx: 'Při resetování zařízení došlo k chybě',
        reportCatchRes: 'Úlovky byly úspěšně nahlášeny',
        reportCatchEx: 'Při hlášení úlovků došlo k chybě',
        setOfflineRes: 'Úspěšně nastaveno jako offline',
        setOfflineEx: 'Při nastavování zařízení jako offline došlo k chybě',
        batteryResetRes: 'Baterie byla úspěšně resetována',
        batteryResetEx: 'Při resetování baterie došlo k chybě',
        updateDeviceRes: 'Zařízení bylo úspěšně aktualizováno',
        updateDeviceEx: 'Při aktualizaci zařízení došlo k chybě',
        getPestControlSystems:
            'Při načítání systémů na ochranu proti škůdcům došlo k chybě',
        tomStatusResetRes: 'Úspěšně resetován stav',
        tomStatusResetEx: 'Při resetování stavu došlo k chybě',
        /* reports */
        getReportsEx: 'Při načítání zpráv došlo k chybě',
        getReportEx: 'Při načítání zprávy došlo k chybě',
        getLastReportDateEx: 'Při načítání data poslední zprávy došlo k chybě',
        /* user mgmt */
        getUsersEx: 'Při načítání uživatelů došlo k chybě',
        getUserEx: 'Při načítání uživatele došlo k chybě',
        getRoleEx: 'Při načítání role došlo k chybě',
        createRoleRes: 'Role byla úspěšně vytvořena',
        createRoleEx: 'Při vytváření role došlo k chybě',
        updateRoleRes: 'Role byla úspěšně aktualizována',
        updateRoleEx: 'Při aktualizaci role došlo k chybě',
        getRolesEx: 'Při načítání rolí došlo k chybě',
        updateUserRes: 'Uživatel byl úspěšně aktualizován',
        updateUserEx: 'Při aktualizaci uživatele došlo k chybě',
        createUserRes: 'Uživatel byl úspěšně vytvořen',
        createUserEx: 'Při vytváření uživatele došlo k chybě',
        deleteUserRes: 'Úspěšně smazáno',
        deleteUserEx: 'Při mazání uživatele došlo k chybě',
        membershipEx: 'Při žádosti o členství uživatele došlo k chybě',
        addToOrgRes: 'Uživatelé byli úspěšně přidáni do organizace',
        addToOrgEx: 'Při přidávání uživatelů do organizace došlo k chybě',
        sendInvitationRes: 'Úspěšné odeslání pozvánky uživateli',
        sendInvitationEx: 'Při odesílání pozvánky došlo k chybě',
        deleteRoleRes: 'Role byla úspěšně smazána',
        deleteRoleEx: 'Při mazání role došlo k chybě',
        /* sharing */
        revokeSharingRes: 'Sdílení bylo úspěšně zrušeno',
        revokeSharingEx: 'Při rušení sdílení došlo k chybě',
        getSharingDataEx: 'Při načítání komponenty sdílení došlo k chybě',
        shareEx: 'Při sdílení entit došlo k chybě',
        /* api-keys */
        getApiKeysEx: 'Při načítání API klíčů došlo k chybě',
        createApiKeyRes: 'API klíč byl úspěšně vytvořen',
        createApiKeyEx: 'Při vytváření API klíču došlo k chybě',
        deleteApiKeyRes: 'API klíč byl úspěšně smazán',
        deleteApiKeyEx: 'Při mazání API klíču došlo k chybě',
        getApiKeyEx: 'Při načítání API klíče došlo k chybě',
        /* register */
        registerUserRes: 'Uživatel byl úspěšně vytvořen',
        registerUserEx: 'Při vytváření uživatele došlo k chybě',
        registerCustomerRes: 'Organizace byla úspěšně vytvořena',
        pleaseUseEmail: 'Použijte prosím e-mail a heslo svého nového uživatele',
        registerCustomerEx: 'Při vytváření organizace došlo k chybě',
        /* detached sharing */
        getDetachedSharingDataEx: 'Došlo k chybě při načítání dat pro sdílení',
        shareDetachedSharingDataRes: 'Úspěšně sdíleno',
        shareDetachedSharingDataEx: 'Došlo k chybě při sdílení entit',
        tomMakeReport: 'Došlo k chybě při vytváření zprávy',
        getTomPicturesEx: 'Došlo k chybě při načítání obrázků TOM',
        mailSendRes: 'E-mail byl úspěšně odeslán',
        mailSendEx: 'Nepodařilo se odeslat e-mail',
        organisationPhoneEx: 'Nepodařilo se uložit telefonní číslo organizace',
        commentDeleteRes: 'Komentář úspěšně smazán',
        commentDeleteEx: 'Došlo k chybě při mazání komentáře',
        commentAddRes: 'Komentář úspěšně přidán',
        commentAddEx: 'Došlo k chybě při přidávání komentáře',
        commentEditRes: 'Komentář úspěšně upraven',
        commentEditEx: 'Došlo k chybě při úpravě komentáře',
        getCommentsEx: 'Došlo k chybě při načítání komentářů',
        deviceImagesAddRes: 'Úspěšně přidáno',
        deviceImagesAddEx: 'Při přidávání došlo k chybě',
        deviceImagesEditRes: 'Úspěšně upraveno',
        deviceImagesEditEx: 'Při úpravách došlo k chybě',
        getDeviceImagesEx: 'Při načítání došlo k chybě',
        getLocationsByCustomerIdEx:
            'An error occurred while loading locations by customer id',
        // subscriptions
        /* onSubscriptionsErrorMessage: 'Něco se pokazilo s předplatným',
        cancelSubscriptionsErrorMessage:
            'Něco se pokazilo při zrušení předplatného' */
        getEscalationLevelEx: 'Při načítání úrovní eskalace došlo k chybě',
        postEscalationLevelEx: 'Při vytváření eskalačních úrovní došlo k chybě',
        postEscalationLevelRes: 'Úspěšně přidány úrovně eskalace',
        getDeviceHistoryEx: 'Při načítání historie zařízení došlo k chybě',
        getUserPreferencesByTypeEx:
            'Chyba při načítání uživatelských preferencí',
        patchUserPreferencesEx:
            'Chyba při aktualizaci uživatelských preferencí',
        postUserPreferencesEx: 'Chyba při vytváření uživatelských preferencí',
        exportFileEx: 'Chyba při exportu souboru',
        getSimCardEx: 'Při načítání SIM karty došlo k chybě',
        updateSimCardRes: 'SIM karta byla úspěšně aktualizována',
        updateSimCardEx: 'Při aktualizaci SIM karty došlo k chybě',
        createSimCardRes: 'SIM karta byla úspěšně vytvořena',
        createSimCardEx: 'Při vytváření SIM karty došlo k chybě'
    },
    common: {
        maintenanceMode: 'Režim údržby',
        maintenanceDurationCustom: 'Vlastní',
        maintenanceDurationMinUnit: 'min',
        maintenanceDurationPositiveOnly:
            'Povolena jsou pouze kladná celá čísla',
        maintenanceDurationDecrease: 'Snížit minuty',
        maintenanceDurationIncrease: 'Zvýšit minuty',
        maintenanceDurationMinutes: 'Minuty údržby',
        exitingMMode: 'Ukončování režimu údržby',
        switchOnMMode: 'Zapnout režim údržby',
        switchOffMMode: 'Vypnout režim údržby',
        switchOnMModeDescr:
            'V režimu údržby nevytvářejí se zprávy a neposílají se oznámení.',
        switchOffMModeDescr: 'Režim údržby bude vypnut.',
        ok: 'Ok',
        name: 'Jméno',
        save: 'Uložit',
        search: 'Hledat',
        cancel: 'Zrušit',
        submit: 'Odeslat',
        clear: 'Resetovat filtry',
        phone: 'Telefon',
        organisationPhone: 'Telefon organizace',
        email: 'E-mail',
        organisation: 'Organizace',
        role: 'Role',
        password: 'Heslo',
        passwordConfirmation: 'Potvrzení hesla',
        changePassword: 'Změnit heslo',
        oldPassword: 'Staré heslo',
        newPassword: 'Nové heslo',
        newPasswordConfiramtion: 'Potvrzení nového hesla',
        errorContactSupport: 'Došlo k chybě, kontaktujte prosím podporu',
        revoke: 'Zrušit',
        share: 'Sdílet',
        delete: 'Smazat',
        back: 'Zpět',
        next: 'Další',
        confirm: 'Potvrdit',
        skip: 'Přeskočit',
        description: 'Popis',
        trap: 'Past',
        fourHours: '4 hodiny',
        sixHours: '6 hodin',
        twelveHours: '12 hodin',
        eighteenHours: '18 hodin',
        twentyFourHours: '24 hodin',
        acceptTerms: 'Přijmout',
        loading: 'Načítání',
        copied: 'Zkopírováno',
        failedToCopy: 'Kopírování selhalo',
        refresh: 'Obnovit',
        confirmationCode: 'Potvrzovací kód',
        passwordLength: 'Heslo má více než 8 znaků.',
        passwordSpecialChar: 'Heslo obsahuje speciální znaky.',
        passwordNumber: 'Heslo obsahuje číslo.',
        passwordCapital: 'Heslo obsahuje velké písmeno.',
        passwordLetter: 'Heslo obsahuje písmeno.',
        nothingWasFound: 'Nic nebylo nalezeno',
        update: 'Aktualizovat',
        newVersionIsAvailable: 'Je dostupná nová verze webové aplikace!',
        pleaseClickUpdate:
            'Klikněte prosím na tlačítko "Aktualizovat" na pravé straně a můžeme začít!',
        required: 'Povinné',
        passwordErrorMessage: 'Heslo není dostatečně silné',
        notValidEmail: 'Neplatný e-mail',
        assigned: 'Přiřazeno',
        assignment: 'Přiřazení',
        done: 'Hotovo',
        settings: 'Nastavení',
        accountSettings: 'Nastavení účtu',
        organisationSettings: 'Nastavení organizace',
        exportCsv: 'Exportovat CSV',
        exportExcel: 'Exportovat Excel',
        exportPdf: 'Exportovat PDF',
        exportQrPdf: 'Exportovat s QR kódem',
        createNew: 'Vytvořit nový',
        fileTooBig: 'Soubor je příliš velký',
        emailTo: 'Komu',
        emailCc: 'Cc',
        advancedInformation: 'Pokročilé informace',
        supportChat: 'Podpůrný chat',
        // confirm: 'Potvrdit'
        account: 'Účet',
        manual: 'Manuál',
        support: 'Podpora',
        about: 'O stránkách',
        online: 'Online',
        offline: 'Offline',
        disconnected: 'Odpojeno',
        notFilterable: 'Není filtrovatelné',
        expandTreeNodes: 'Rozbalit všechny uzly',
        collapseTreeNodes: 'Sbalit všechny uzly',
        applyFilters: 'Použít filtry',
        close: 'Zavřít',
        login: 'Přihlášení',
        installation: 'Instalace',
        success: 'Úspěch'
    },
    tom: {
        openTomBtnTitle: 'Nové obrázky k přezkoumání',
        loadMore: 'Načíst více',
        contentType: 'Typ obsahu',
        reportType: 'Typ zprávy',
        createdAt: 'Vytvořeno',
        updatedAt: 'Aktualizováno',
        status: 'Stav',
        bedbug: 'Štěnice',
        ant: 'Mravenec',
        roach: 'Šváb',
        moth: 'Mol',
        cockroach: 'Šváb',
        fly: 'Hmyz',
        other: 'Jiné',
        mouse: 'Myš',
        rat: 'Krysa',
        activated: 'Aktivováno',
        activity: 'Aktivita',
        falseTrigger: 'Falešný spouštěč',
        reviseReport: 'Revidovat zprávu',
        openTom: 'Otevřít TOM',
        user_processed: 'Zpracoval uživatel',
        not_processed: 'Nezpracováno',
        ai_processed: 'Zpracovalo AI',
        ai_and_user_processed: 'Zpracovalo AI a uživatel',
        tomMode: 'Režim TOM',
        period: 'Období',
        pileEmpty: 'Hromada je prázdná.',
        allProcessed: 'Všechny obrázky zpracovány.',
        deviceName: 'Název zařízení',
        companyName: 'Název společnosti',
        dateTime: 'Datum a čas',
        operationMode: 'Režim provozu',
        ok: 'OK',
        warning: 'Varování',
        critical: 'Kritický',
        comments: 'Komentáře',
        aiProcessed: 'Tento obrázek byl automaticky zpracován pomocí AI',
        userProcessed: 'Tento obrázek zpracoval uživatel',
        location: 'Lokalita',
        system: 'Systém',
        noDevicePictures: 'Zatím žádné obrázky',
        noPictures: 'Zatím nejsou žádné obrázky TOM',
        notUsingTom: 'Ještě nepoužíváte náš nový produkt "TOM"?',
        discoverTom: 'Objevte TOM',
        reportedBy: 'Nahlásil',
        amount: 'Množství',
        makeReport: 'Vytvořit zprávu',
        relevantPictures: 'Relevantní obrázky',
        allPictures: 'Všechny obrázky'
    },
    mobileAppScreen: {
        title: 'Momentálně optimalizujeme naši webovou aplikaci pro mobilní zařízení.',
        subtitle:
            'Pro nejlepší uživatelský zážitek si prosím stáhněte naši aplikaci v App Store nebo Google Play Store.'
    },
    addressForm: {
        firstName: 'Jméno',
        lastName: 'Příjmení',
        company: 'Společnost',
        streetAndNumber: 'Ulice & číslo domu',
        zip: 'PSČ',
        city: 'Město',
        country: 'Země',
        note: 'Poznámka',
        companyNameRequireValidationMessage: 'Název společnosti je povinný',
        companyNameMinLengthValidationMessage:
            'Název společnosti je příliš krátký',
        companyNameMaxLengthValidationMessage:
            'Název společnosti je příliš dlouhý',
        companyIsValidValidationMessage: 'Neplatný název společnosti',
        nameRequireValidationMessage: 'Jméno je povinné',
        nameMinLengthValidationMessage: 'Jméno je příliš krátké',
        nameMaxLengthValidationMessage: 'Jméno je příliš dlouhé',
        nameIsValidValidationMessage: 'Neplatné jméno',
        lastNameRequireValidationMessage: 'Příjmení je povinné',
        lastNameMinLengthValidationMessage: 'Příjmení je příliš krátké',
        lastNameMaxLengthValidationMessage: 'Příjmení je příliš dlouhé',
        lastNameIsValidValidationMessage: 'Neplatné příjmení',
        addressRequireValidationMessage: 'Ulice & číslo domu je povinné',
        addressIsValidValidationMessage: 'Neplatný formát ulice & číslo domu',
        zipCodeRequireValidationMessage: 'PSČ je povinné',
        zipCodeIsValidValidationMessage: 'Neplatné PSČ',
        cityRequireValidationMessage: 'Město je povinné',
        cityIsValidValidationMessage: 'Neplatné město',
        countryRequireValidationMessage: 'Země je povinná',
        countryIsValidValidationMessage: 'Neplatný název země'
    },
    billing: {
        billing: 'Fakturace',
        externalUsersCreationNotice:
            'Noví externí uživatelé vytvořeni po 01.01.2025 budou zpoplatněni částkou 2,50 € bez DPH měsíčně. Přehled vašich měsíčních předplatných najdete v dashboardu fakturace.',
        escalationLevelsCreationNotice:
            'Nové e-mailové adresy použité pro úrovně eskalace přiřazené po 01.01.2025 budou zpoplatněny částkou 2,50 € bez DPH měsíčně. Přehled vašich měsíčních předplatných najdete v dashboardu fakturace.',
        billingDashboard: 'Dashboard fakturace',
        lastHeartbeat: 'Poslední heartbeat',
        removedAt: 'Odstraněno',
        externalUsers: 'Externí uživatelé',
        amount: 'Částka',
        apiDevices: 'API zařízení',
        monetisation: 'Monetizace',
        itCanUpToAMinute: 'Může trvat až minutu',
        currentMonth: 'Aktuální měsíc'
    }
}

export default cz
